module.exports = __webpack_public_path__ + "img/sdg_es_(8).d0d701fa.png";